import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { motion } from 'framer-motion'
import { FaArrowLeft } from 'react-icons/fa'
import Examples from './Examples'
import Exercises from './Exercises'
import Game from './Game'
import Explanation from './Explanation'
import topicDetailsData from './Topics.json'
import './styles.css'

interface Exercise {
  question: string
  options: (string | number)[]
  correctAnswer: string | number
}

interface GameDetails {
  title: string
  description: string
  characters: Record<string, string>
  questions: { question: string; options: (string | number)[]; answer: string }[]
}

interface TopicDetails {
  explanation: string
  images: string[]
  examples: string[]
  exercises: Exercise[]
  game?: GameDetails
}

const Topic = () => {
  const navigate = useNavigate()
  const params = useParams()
  const lessonName: any = params

  console.log(lessonName, 'ldlal')

  const [currentExampleIndex, setCurrentExampleIndex] = useState(0)
  const [selectedAnswer, setSelectedAnswer] = useState<string | number | null>(null)
  const [feedback, setFeedback] = useState<string>('')
  const [isExplanationPhase, setIsExplanationPhase] = useState(true)
  const [isAnswerSubmitted, setIsAnswerSubmitted] = useState(false)
  const [isCorrect, setIsCorrect] = useState(false)
  const [isComplete, setIsComplete] = useState(false)
  const [isSpeaking, setIsSpeaking] = useState(false)
  const [speechUtterance, setSpeechUtterance] = useState<SpeechSynthesisUtterance | null>(null)
  const [selectedData, setSelectedData] = useState<string>('')
  const [showContent, setShowContent] = useState<boolean>(false)
  const [showQuestions, setShowQuestions] = useState(false)

  const cardContents = [
    { title: 'व्याख्या', key: 'explanation', bgColor: '#E3F2FD', textColor: '#0D47A1' },
    { title: 'उदाहरण', key: 'examples', bgColor: '#E8F5E9', textColor: '#1B5E20' },
    { title: 'अभ्यास', key: 'exercises', bgColor: '#FFFDE7', textColor: '#F9A825' }
    // { title: 'खेल', key: 'game', bgColor: '#FFEBEE', textColor: '#B71C1C' }
  ]

  const topicDetails: any = topicDetailsData
  const topic = topicDetails[lessonName?.name!]

  const [answerVisibility, setAnswerVisibility] = useState(
    topic?.game?.questions.reduce((acc: any, curr: any, index: any) => {
      acc[index] = false // Initially set all answers to be hidden
      return acc
    }, {})
  )

  const handleAnswerChange = (e: any) => {
    setSelectedAnswer(e.target.value)
  }

  const handleSubmit = () => {
    if (selectedAnswer === null) {
      setFeedback('कृपया एक उत्तर चुनें।')
      return
    }

    const isCorrectAnswer = selectedAnswer === topic?.exercises[currentExampleIndex]?.correctAnswer
    setIsCorrect(isCorrectAnswer)
    setFeedback(isCorrectAnswer ? 'सही! बढ़िया काम!' : 'गलत. फिर से प्रयास करें.')
    setIsAnswerSubmitted(true)
  }

  const handleNextExample = () => {
    if (currentExampleIndex < topic.exercises.length - 1) {
      setCurrentExampleIndex(currentExampleIndex + 1)
      setSelectedAnswer(null)
      setFeedback('')
      setIsAnswerSubmitted(false)
      setIsCorrect(false)
    } else {
      setIsComplete(true)
    }
  }

  const handleNavigate = () => {
    navigate('/learning/class1')
    setIsComplete(false)
    setCurrentExampleIndex(0)
    setFeedback('')
  }

  const percentageComplete = Math.round(
    ((currentExampleIndex + 1) / topic?.exercises?.length) * 100
  )

  const speakExplanation = (text: string) => {
    console.log(text, 'tetsttstst')
    const synth = window.speechSynthesis

    // If speech is already playing, stop it
    if (isSpeaking && speechUtterance) {
      synth.cancel() // Stop the current speech
      setIsSpeaking(false) // Update state
      return
    }

    console.log(isSpeaking, 'sisisisisis')
    // Otherwise, start a new speech
    const utterance = new SpeechSynthesisUtterance(text)

    // Set the language for Hindi if the text is in Hindi, otherwise use default
    if (isHindiText(text)) {
      utterance.lang = 'hi-IN' // Hindi language code
    } else {
      utterance.lang = 'en-US' // Default to English
    }

    utterance.onstart = () => {
      setIsSpeaking(true) // Set isSpeaking to true when the speech starts
    }

    console.log(isSpeaking, 'sdcdscsdcdcscsd')
    utterance.onend = () => {
      setIsSpeaking(false) // Set isSpeaking to false when the speech ends
    }

    synth.speak(utterance)
    setSpeechUtterance(utterance) // Save the utterance to stop later
  }
  const isHindiText = (text: string) => {
    return /[\u0900-\u097F]/.test(text)
  }
  const handleDataButtonClick = (dataType: string) => {
    setSelectedData(dataType)
    setShowContent(true)
    setIsSpeaking(false) // Reset speaking state
    setSpeechUtterance(null) // Reset the utterance

    // Access window.speechSynthesis directly
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel() // Stop any ongoing speech
    }
  }

  console.log(window?.speechSynthesis, 'sdcsdcscscscsc')

  const exceercise = (text: any) => {
    const question = text.question
    const options = text.options.join(', ') // Join options into a string, separated by commas
    return `आइए, प्रश्नोत्तरी शुरू करें \ प्रश्न: ${question} \ सही विकल्प चुनें: ${options}`
  }

  const speakGame = (gameData: any) => {
    setIsSpeaking(true) // Set to true when speaking starts

    const title = `${gameData.title}`
    speakExplanation(title) // Use the speakExplanation function for title

    // Once title is spoken, move to the description
    const description = `विवरण: ${gameData.description}`
    speakExplanation(description) // Use the speakExplanation function for description

    // After description, read characters
    const characters = Object.keys(gameData.characters)
    const readCharacter = (index: number) => {
      if (index < characters.length) {
        const character = characters[index]
        const characterDescription = `${character}: ${gameData.characters[character]}`
        speakExplanation(characterDescription) // Use the speakExplanation function for characters

        // After the character is spoken, move to the next character
        setTimeout(() => {
          readCharacter(index + 1)
        }, 1500) // Optional delay between characters for better user experience
      }
    }

    readCharacter(0) // Start reading characters

    // After characters, read the questions
    const readQuestions = () => {
      const questions = gameData?.game?.questions || []

      questions.forEach((questionData: any, index: any) => {
        const questionText = `प्रश्न: ${questionData?.question}`
        const optionsText = questionData?.options?.join(' , ') || ''
        const questionToSpeak = `${questionText} सही विकल्प चुनें: ${optionsText}`

        speakExplanation(questionToSpeak) // Use the speakExplanation function for questions
      })
    }

    // Start reading questions after characters are spoken
    setTimeout(() => {
      readQuestions() // Read the questions after character descriptions
    }, characters.length * 1500) // Optional delay after characters before starting questions
  }

  return (
    <>
      <div className='container mt-5'>
        <motion.button
          className='btn btn-outline-light position-absolute top-0 start-0 m-3 d-flex align-items-center justify-content-center'
          onClick={() => navigate(-1)}
          whileHover={{ scale: 1.1, rotate: 10 }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.3 }}
          style={{
            borderRadius: '50%',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            padding: '10px 15px',
            fontSize: '1.5rem',
            border: 'none',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            zIndex: 1,
            transition: 'all 0.3s ease-in-out'
          }}
        >
          <FaArrowLeft />
        </motion.button>

        <div className='text-center mb-5'>
          <h4 className='display-6 font-weight-bold text-primary'>{`विषय : ${lessonName?.name}`}</h4>
        </div>

        <div className='d-flex justify-content-center flex-wrap mb-4'>
          {cardContents.map((content, index) => (
            <motion.button
              className='btn btn-lg d-flex flex-column align-items-center rounded-4 p-5 mx-3 mb-3'
              onClick={() => handleDataButtonClick(content.key)}
              whileHover={{ scale: 1.1, rotate: 10 }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.3 }}
              key={index}
              style={{
                background: content.bgColor,
                color: content.textColor,
                border: 'none',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                fontSize: '1.8rem',
                transition: 'all 0.3s ease-in-out',
                padding: '20px 40px'
              }}
            >
              <span
                style={{
                  fontWeight: 'bold',
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  fontSize: '3rem'
                }}
              >
                {content.title}
              </span>
            </motion.button>
          ))}
        </div>

        {showContent && selectedData === 'explanation' && (
          <Explanation topic={topic} isSpeaking={isSpeaking} speakExplanation={speakExplanation} />
        )}

        {showContent && selectedData === 'examples' && (
          <Examples topic={topic} isSpeaking={isSpeaking} speakExplanation={speakExplanation} />
        )}

        {showContent && selectedData === 'exercises' && (
          <Exercises
            topic={topic}
            currentExampleIndex={currentExampleIndex}
            isSpeaking={isSpeaking}
            speakExplanation={speakExplanation}
            handleNextExample={handleNextExample}
          />
        )}

        {showContent && selectedData === 'game' && topic?.game && (
          <Game
            topic={topic}
            showQuestions={showQuestions}
            setShowQuestions={setShowQuestions}
            answerVisibility={answerVisibility}
            setAnswerVisibility={setAnswerVisibility}
          />
        )}
      </div>

      {isComplete && (
        <div className='party-animation'>
          <div className='party-popup'>
            <h2 className='text-center fw-bolder '>अद्भुत!</h2>
            <p className='fw-2'>आपने इस अभ्यास को शानदार तरीके से पूरा किया।</p>
            <div className='party-cracker'>🎉</div>
            <button onClick={handleNavigate} className='btn btn-success mt-4'>
              धन्यवाद
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default Topic
